import firebase from 'firebase';
import 'firebase/firestore';

export default {
  namespaced: true,
  state: {
    categoryList: []
  },
  mutations: {
    addCategory(state: any, category: any){
      state.categoryList.push(category);
    },
    resetCategoryList(state: any){
      state.categoryList = [];
    }
  },
  actions: {
    // カテゴリー情報を取得する
    fetchCategories({ commit }: { commit: any }){
      // stateをリセットする
      commit('resetCategoryList');
      const db = firebase.firestore();
      db.collection('categories').get().then(snapshot => {
        snapshot.forEach(doc => commit('addCategory', doc.data()))
      })
    }
  },
  getters: {
    categoryList: (state: any) => (state.categoryList ? state.categoryList : []),
  }
};
